module.exports = __webpack_public_path__ + "img/partner 02.d6ad93dc.jpg";